export const PostImageUrl =
  "https://res.cloudinary.com/tradein/image/upload/v1634651417/";
export const ProfileImageUrl =
  "http://res.cloudinary.com/tradein/image/upload/v1635581673/";

// login
export const UserLogin = "user/login/";
export const UserTokenRefresh = "user/token/refresh/";
export const UserAccountCreate = "user/account/create/";
export const UserAccountUpdate = "user/account/update/";
export const UserCheckUsername = "user/check/username/";
export const GetUserDetails = "user/mydetails/";

// post
export const RetrievePost = "post/single/retrieve/";
export const RetrieveAllPost = "post/all/retrieve/";
export const PostSaved = "post/save/";
export const CreatePost = "post/create/";
export const PostDelete = "post/delete/";
export const PostEdit = "post/edit/";

// payment
export const ReservePayment = "post/reservepay/";
export const ReservePaymentSuccess = "post/reservepayment/success/";
export const ProductPayment = "post/productpay/";
export const ProductPaymentSuccess = "post/productpayment/success/";

// Question
export const PostQuestion = "post/question/";
export const PostAnswer = "post/answer/";

// Account
export const ProfileBuy = "user/buy/";
export const ProfileDonate = "user/donate/";
export const ProfileExchange = "user/exchange/";
export const ProfileOrders = "user/orders/";
export const ProfileWishlist = "user/wishlist/";
export const ProfileUser = "user/details/";
export const AddressEdit = "user/account/update/";
export const EditImage = "user/image/";
export const ProfileReserves = "user/reserves/";


// additionals
export const AllBrands = "post/allbrands/";